import { render } from "./TouchBanner.vue?vue&type=template&id=7c7015be"
import script from "./TouchBanner.vue?vue&type=script&lang=js"
export * from "./TouchBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__